import { Box, Divider } from '@chakra-ui/react';
import React, { useState } from 'react';
import { UserPlus } from 'react-feather';
import Lottie from 'react-lottie';
import { useHistory } from 'react-router-dom';
import animationData from '../../../assets/animations/rocket.json';
import { Card } from '../../../components/Card';
import { AuthContainer } from '../../../components/container/AuthContainer';
import { PageContainer } from '../../../components/container/PageContainer';
import { BackToLoginButton } from '../../../components/styled-chakra/BackToLoginButton';
import { useConfig } from '../../../hooks/useConfig';
import { UserMatchType } from '../../../types/types';
import { LoadingPage } from '../../util-pages/LoadingPage';
import { CheckUserRegistration } from './CheckUserRegistration';
import { RegisterUser } from './RegisterUser';
import { TrialRegistrationAlert } from './TrialRegistrationAlert';

export const RegisterPage = () => {
  const [userMatch, setUserMatch] = useState<UserMatchType | null>(null);
  const [isTrailRegistrationAlertOpen, setIsTrailRegistrationAlertOpen] =
    useState<boolean>(true);
  const history = useHistory();
  const firebaseConfig = useConfig();

  if (!firebaseConfig) return <LoadingPage />;

  return (
    <PageContainer center>
      <AuthContainer
        title="Gleich kann es losgehen"
        subtitle="Nur noch eine Registrierung entfernt"
        icon={
          <Lottie
            isClickToPauseDisabled={true}
            options={{
              loop: true,
              autoplay: true,
              animationData,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
              },
            }}
            style={{ width: '66%', height: 'auto' }}
          />
        }
      >
        <Card title="Registrierung" icon={UserPlus} animate={true}>
          <Box textAlign="left">
            {!userMatch && (
              <CheckUserRegistration
                firebaseConfig={firebaseConfig}
                userMatch={(user) => setUserMatch(user)}
              />
            )}
            {userMatch && !userMatch.found && (
              <>
                <RegisterUser
                  firebaseConfig={firebaseConfig}
                  trial={true}
                  userMatch={userMatch}
                />
                <TrialRegistrationAlert
                  firebaseConfig={firebaseConfig}
                  isOpen={isTrailRegistrationAlertOpen}
                  onClose={() => setIsTrailRegistrationAlertOpen(false)}
                  onCancel={() => {
                    setIsTrailRegistrationAlertOpen(false);
                    history.push('/register');
                  }}
                />
              </>
            )}
            {userMatch && userMatch.found && (
              <RegisterUser
                firebaseConfig={firebaseConfig}
                trial={false}
                userMatch={userMatch}
              />
            )}
          </Box>
          <Divider mt={4} />
          <BackToLoginButton />
        </Card>
      </AuthContainer>
    </PageContainer>
  );
};
